__webpack_require__.p = "https://clients.mintel.com/bundles/cf-app-shell/";